import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @Employees
 * @Employees
 * @employees
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"name","type":"text","placeholder":"Name","label":"Name","header":"Name","width":110,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"fieldType":"Link","textAlign":"Center","displayinregisterForm":"true","disabled":false,"globalSearchField":"true","show":true,"field":"name","addFormOrder":1,"editFormOrder":1,"fieldName":"name","mobile":true,"displayInSettings":true},{"name":"email","type":"email","placeholder":"Email","label":"Email","id":"email","width":150,"displayinaddForm":"true","displayineditForm":"false","displayinlist":"true","controllerName":null,"textAlign":"Center","displayinregisterForm":"true","disabled":false,"show":true,"globalSearchField":"true","field":"email","header":"Email","addFormOrder":2,"editFormOrder":2,"mobile":true,"displayInSettings":true},{"name":"address","type":"textarea","placeholder":"Address","label":"Address","id":"address","width":180,"displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"textAlign":"Center","show":true,"disabled":false,"globalSearchField":"true","field":"address","header":"Address","addFormOrder":3,"editFormOrder":3,"mobile":true,"displayInSettings":true},{"name":"role","type":"dropDown","placeholder":"Role","label":"Role","header":"Role","derivedValue":"role=undefined","actions":[],"width":110,"actionsNumber":[],"id":"role","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"options":[],"textAlign":"Center","show":true,"disabled":false,"field":"role","mobile":true,"globalSearchField":"true","required":true,"displayInSettings":true,"fieldType":"dropDown","addFormOrder":4,"editFormOrder":4},{"name":"phone","type":"text","placeholder":"Phone","label":"Phone","id":"phone","width":110,"displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"textAlign":"Center","displayinregisterForm":"true","show":true,"disabled":false,"field":"phone","header":"Phone","addFormOrder":5,"editFormOrder":5,"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"reportingTo","type":"relateAutoComplete","placeholder":"ReportingTo","label":"ReportingTo","header":"ReportingTo","derivedValue":"reportingTo=undefined","actions":[],"actionsNumber":[],"id":"reportingTo","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":"employee","searchField":"name","fieldType":"relateAutoComplete","controllerId":1001,"searchApi":"employees","width":110,"textAlign":"Center","show":true,"disabled":false,"field":"reportingTo","addFormOrder":6,"editFormOrder":6,"mobile":true,"displayInSettings":true},{"name":"password","type":"password","placeholder":"password","label":"password","id":"password","displayinaddForm":"true","displayineditForm":"false","displayinlist":"false","controllerName":null,"textAlign":"Center","show":false,"displayInSettings":false,"disabled":false,"field":"password","header":"password","addFormOrder":7,"editFormOrder":7,"mobile":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":false,"show":true,"field":"created","addFormOrder":10,"editFormOrder":10,"mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":false,"show":true,"field":"updated","addFormOrder":11,"editFormOrder":11,"mobile":true,"displayInSettings":true}]
 * @[{"name":"name","type":"text","placeholder":"Name","label":"Name","width":110,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"fieldType":"Link","displayinregisterForm":"true","disabled":false,"globalSearchField":"true","show":true,"addFormOrder":1,"editFormOrder":1,"fieldName":"name","mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"email","type":"email","placeholder":"Email","label":"Email","id":"email","width":150,"displayinaddForm":"true","displayineditForm":"false","displayinlist":"true","controllerName":null,"displayinregisterForm":"true","disabled":false,"show":true,"globalSearchField":"true","addFormOrder":2,"editFormOrder":2,"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":true},{"name":"address","type":"textarea","placeholder":"Address","label":"Address","id":"address","width":180,"displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"show":true,"disabled":false,"globalSearchField":"true","addFormOrder":3,"editFormOrder":3,"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"role","type":"dropDown","placeholder":"Role","label":"Role","derivedValue":"role=undefined","actions":[],"width":110,"actionsNumber":[],"id":"role","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"options":[],"show":true,"disabled":false,"mobile":true,"globalSearchField":"true","required":true,"displayInSettings":true,"fieldType":"dropDown","addFormOrder":4,"editFormOrder":4,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"phone","type":"text","placeholder":"Phone","label":"Phone","id":"phone","width":110,"displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"displayinregisterForm":"true","show":true,"disabled":false,"addFormOrder":5,"editFormOrder":5,"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":false,"isEditFormHidden":false},{"name":"reportingTo","type":"relateAutoComplete","placeholder":"ReportingTo","label":"ReportingTo","derivedValue":"reportingTo=undefined","actions":[],"actionsNumber":[],"id":"reportingTo","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":"employee","searchField":"name","fieldType":"relateAutoComplete","controllerId":1001,"searchApi":"employees","width":110,"show":true,"disabled":false,"addFormOrder":6,"editFormOrder":6,"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"password","type":"password","placeholder":"password","label":"password","id":"password","displayinaddForm":"true","displayineditForm":"false","displayinlist":"false","controllerName":null,"show":true,"displayInSettings":false,"disabled":false,"addFormOrder":7,"editFormOrder":7,"mobile":true,"isAddFormHidden":false,"isEditFormHidden":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":false,"show":true,"addFormOrder":10,"editFormOrder":10,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":false,"show":true,"addFormOrder":11,"editFormOrder":11,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */
const Employees = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [rolesList, setRolesList] = useState([]);
  const [gotRoles, setgotRoles] = useState(false);
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  const [paramsObj, setParamsObj] = useState();

  const params = useParams();
  useEffect(() => {
    getRoleListFromServer();
    let screenPermissions = RolePermissions.screenPermissions("Employees");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    } if (params.id && params.id.includes('-')) {
      let arr = params.id.split('-');
      setParamsObj({
        facilityName: arr[0],
        storageUnitId: arr[1],
      })
    } else if (params && window.location.href.includes("redirect")) {
      const storedLoginBody = JSON.parse(localStorage.getItem("loginCredentials"));
      if (storedLoginBody && storedLoginBody.role) {
        setParamsObj({ role: storedLoginBody.role });
      }
    } else {
      setParamsObj({})
    }
  }, []);

  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  // componentDidMount = () => {
  //   //Screen permisions value can be edit,view, no view
  //   let screenPermissions = RolePermissions.screenPermissions('Test');
  //   if (screenPermissions) {
  //     this.setState({
  //       rolePermission: screenPermissions
  //     })
  //   }
  //   // this.getRoleListFromServer()
  // }
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };
  const getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest("GET", url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = [];
          for (let obj of res.roles) {
            if (obj.role && obj.role !== 'Admin' && obj.role !== 'Super Admin' && obj.role !== 'Staff') rolesList.push({ value: obj.role, label: obj.role });
          }
          // await this.setState({ rolesList: rolesList,gotRoles:true });
          setRolesList(rolesList);
          setgotRoles(true);
        }
      })
      .catch((err) => {
        setgotRoles(true);
        return err;
      });
  };
  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: false,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: false,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "displayName",
        type: "text",
        placeholder: "Name",
        label: "Name",
        header: "Name",
        width: 110,
        id: "displayName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        displayinregisterForm: "true",
        disabled: false,
        globalSearchField: "true",
        show: true,
        field: "displayName",
        addFormOrder: 1,
        editFormOrder: 1,
        fieldName: "name",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "email",
        type: "email",
        placeholder: "Email",
        label: "Email",
        id: "email",
        width: 150,
        displayinaddForm: "true",
        displayineditForm: "false",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        displayinregisterForm: "true",
        disabled: false,
        show: true,
        globalSearchField: "true",
        field: "email",
        header: "Email",
        addFormOrder: 2,
        editFormOrder: 2,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "address",
        type: "textarea",
        placeholder: "Address",
        label: "Address",
        id: "address",
        width: 180,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        show: false,
        disabled: false,
        globalSearchField: "true",
        field: "address",
        header: "Address",
        addFormOrder: 3,
        editFormOrder: 3,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "role",
        type: "dropDown",
        placeholder: "Role",
        label: "Role",
        header: "Role",
        derivedValue: "role=undefined",
        actions: [],
        width: 110,
        actionsNumber: [],
        id: "role",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: [],
        textAlign: "Center",
        show: true,
        disabled: false,
        field: "role",
        mobile: true,
        // style: {
        //   width: '80px'
        // },
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        // fieldType: "dropDown",
        fieldType: "Badge",
        addFormOrder: 4,
        editFormOrder: 4,
      },
      {
        name: "phone",
        type: "text",
        placeholder: "Phone",
        label: "Phone",
        id: "phone",
        width: 110,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        displayinregisterForm: "true",
        show: false,
        disabled: false,
        field: "phone",
        header: "Phone",
        addFormOrder: 5,
        editFormOrder: 5,
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "reportingTo",
        type: "relateAutoComplete",
        placeholder: "ReportingTo",
        label: "ReportingTo",
        header: "ReportingTo",
        derivedValue: "reportingTo=undefined",
        actions: [],
        actionsNumber: [],
        id: "reportingTo",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: "employee",
        searchField: "name",
        fieldType: "relateAutoComplete",
        controllerId: 1001,
        searchApi: "employees",
        width: 110,
        textAlign: "Center",
        show: false,
        disabled: false,
        field: "reportingTo",
        addFormOrder: 6,
        editFormOrder: 6,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "password",
        type: "password",
        placeholder: "password",
        label: "password",
        id: "password",
        displayinaddForm: "true",
        displayineditForm: "false",
        displayinlist: "false",
        controllerName: null,
        textAlign: "Center",
        show: false,
        displayInSettings: false,
        disabled: false,
        field: "password",
        header: "password",
        addFormOrder: 7,
        editFormOrder: 7,
        mobile: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: false,
        show: false,
        field: "created",
        addFormOrder: 10,
        editFormOrder: 10,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: false,
        show: false,
        field: "updated",
        addFormOrder: 11,
        editFormOrder: 11,
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "firstName",
        type: "text",
        placeholder: "First Name",
        label: "First Name",
        width: 110,
        id: "name",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        fieldType: "Link",
        displayinregisterForm: "true",
        disabled: false,
        globalSearchField: "true",
        show: true,
        addFormOrder: 1,
        editFormOrder: 1,
        required: true,
        fieldName: "firstName",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "lastName",
        type: "text",
        placeholder: "Last Name",
        label: "Last Name",
        width: 110,
        id: "lastName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        fieldType: "Link",
        displayinregisterForm: "true",
        disabled: false,
        globalSearchField: "true",
        show: true,
        addFormOrder: 2,
        editFormOrder: 2,
        fieldName: "lastName",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        required: true,

      },
      {
        name: "email",
        type: "email",
        placeholder: "email@yopmail.com",
        label: "Email",
        id: "email",
        width: 150,
        displayinaddForm: "true",
        displayineditForm: "false",
        displayinlist: "true",
        controllerName: null,
        displayinregisterForm: "true",
        disabled: false,
        fieldName: 'email',
        show: true,
        globalSearchField: "true",
        addFormOrder: 3,
        editFormOrder: 3,
        mobile: true,
        required: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "role",
        type: "dropDown",
        placeholder: "Role",
        label: "Role",
        derivedValue: "role=undefined",
        actions: [],
        width: 110,
        actionsNumber: [],
        id: "role",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: [],
        show: true,
        disabled: false,
        mobile: true,
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        addFormOrder: 4,
        editFormOrder: 4,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "phoneNumber",
        type: "text",
        placeholder: "Phone Number",
        label: "Phone Number",
        id: "phone",
        width: 110,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        displayinregisterForm: "true",
        show: true,
        disabled: false,
        addFormOrder: 5,
        editFormOrder: 5,
        required: true,
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        // style: {
        //   color: "#0e4768",
        //   cursor: "pointer",
        //   textTransform: "capitalize",
        // },
        isAddFormHidden: false,
        isEditFormHidden: false,
      },

    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
  };
  const getMobileTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "name",
        type: "text",
        placeholder: "Name",
        label: "Name",
        header: "Name",
        width: 110,
        id: "name",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        fieldType: "Link",
        textAlign: "Center",
        displayinregisterForm: "true",
        disabled: false,
        globalSearchField: "true",
        show: true,
        field: "name",
        addFormOrder: 1,
        editFormOrder: 1,
        fieldName: "name",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "email",
        type: "email",
        placeholder: "Email",
        label: "Email",
        id: "email",
        width: 150,
        displayinaddForm: "true",
        displayineditForm: "false",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        displayinregisterForm: "true",
        disabled: false,
        show: true,
        globalSearchField: "true",
        field: "email",
        header: "Email",
        addFormOrder: 2,
        editFormOrder: 2,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "address",
        type: "textarea",
        placeholder: "Address",
        label: "Address",
        id: "address",
        width: 180,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        show: true,
        disabled: false,
        globalSearchField: "true",
        field: "address",
        header: "Address",
        addFormOrder: 3,
        editFormOrder: 3,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "role",
        type: "dropDown",
        placeholder: "Role",
        label: "Permissioned Role",
        header: "Role",
        derivedValue: "role=undefined",
        actions: [],
        width: 110,
        actionsNumber: [],
        id: "role",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: [],
        textAlign: "Center",
        show: true,
        disabled: false,
        field: "role",
        mobile: true,
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        addFormOrder: 4,
        editFormOrder: 4,
      },
      {
        name: "phone",
        type: "text",
        placeholder: "Phone",
        label: "Phone",
        id: "phone",
        width: 110,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        textAlign: "Center",
        displayinregisterForm: "true",
        show: true,
        disabled: false,
        field: "phone",
        header: "Phone",
        addFormOrder: 5,
        editFormOrder: 5,
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "reportingTo",
        type: "relateAutoComplete",
        placeholder: "ReportingTo",
        label: "ReportingTo",
        header: "ReportingTo",
        derivedValue: "reportingTo=undefined",
        actions: [],
        actionsNumber: [],
        id: "reportingTo",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: "employee",
        searchField: "name",
        fieldType: "relateAutoComplete",
        controllerId: 1001,
        searchApi: "employees",
        width: 110,
        textAlign: "Center",
        show: true,
        disabled: false,
        field: "reportingTo",
        addFormOrder: 6,
        editFormOrder: 6,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "password",
        type: "password",
        placeholder: "password",
        label: "password",
        id: "password",
        displayinaddForm: "true",
        displayineditForm: "false",
        displayinlist: "false",
        controllerName: null,
        textAlign: "Center",
        show: false,
        displayInSettings: false,
        disabled: false,
        field: "password",
        header: "password",
        addFormOrder: 7,
        editFormOrder: 7,
        mobile: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: false,
        show: true,
        field: "created",
        addFormOrder: 10,
        editFormOrder: 10,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: false,
        show: true,
        field: "updated",
        addFormOrder: 11,
        editFormOrder: 11,
        mobile: true,
        displayInSettings: true,
      },
    ];
    return data;
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };
  // submit1 = item => {
  //   let x = employeesFields
  //   let objemployees = {}

  //   objemployees["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objemployees[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objemployees,
  //     newFormFields: formFields
  //   });
  // }

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };
  const getChangedRoleOptions = () => {
    let fields = getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name == "role") {
          obj.options = rolesList && rolesList.length > 0 ? rolesList : [];
        }
      }
    }
    return fields;
  };
  const saveDataToServer = async (item, field, value) => {
    let body = item[0];
    body[field] = value;
    let userBody = Object.assign({}, body);
    // this.setState({
    //   isLoading: true
    // });
    if (body) {
      let method, apiUrl;
      method = "PUT";
      apiUrl = `${apiCalls["employees"]}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
          // this.setState({
          //   isLoading: false
          // });
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  return (
    <span>
      {/* {gotRoles && paramsObj && ( */}
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getChangedRoleOptions}
          // MobileTableFields={this.getMobileTableFields}
          // getTableFields={this.getTableFields}
          // formFields={this.getFormFields}
          //
          addRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          editRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          exportRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          sample={false}
          // globalSearch={'Display Name/Email'}
          // type='Employees'
          // apiUrl={apiCalls.Employees}

          // exportRequried={true}

          printRequried={false}
          actionsTypes={false}
          // [
          // {
          //   name: "Delete",
          //   options: [
          //     {
          //       label: "Delete",
          //       value: "Delete",
          //       show:
          //         rolePermission && rolePermission == "Edit" ? true : false,
          //       multiple: true,
          //     },
          //   ],
          // },

          // {
          //   'name': 'Block',
          //   "options": [
          //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'ResetPassword',
          //   "options": [
          //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'Submit',
          //   'action': this.submit,
          //   "options": [
          //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
          //   ]
          // },
          // {
          //   name: "newModel",
          //   action: this.submit1,
          //   options: [
          //     { label: "newModel", value: "newModel", show: true, multiple: false }
          //   ]
          // }
          // ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={false}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={false}
          dateSearchRequired={false}
          refresh={true}
          searchInDateRangeField={""}
          sampleFilePath={filePath["employees"]}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          globalSearch={"Name / E-mail"}
          type="Employees"
          routeTo={apiCalls["employees"]}
          sideFormLeftOrRight=""
          displayViewOfForm="modal"
          apiResponseKey={apiCalls["employees"].toLowerCase()}
          apiUrl={apiCalls["employees"]}
          selectedId={params.id}
          params={paramsObj}
        />
      {/* )} */}
      {isOpenFormModal ? (
        <FormModal
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="employees"
          apiUrl={apiCalls["employees"]}
        />
      ) : null}
    </span>
  );
};

export default Employees;
